import React,{useEffect, useState} from "react";  
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import {getListProductSame} from '../../../service/productDetailService'
import {responsiveproductlistmobile}  from "../../../utils/constant";
import { ItemDefault} from "../../../components/mobile/product";
import { navigate } from "gatsby";

const ProductSame = ({sku})=>{
    var [dataItems, setdataItems] = useState([]);
    useEffect(()=>{
      try {
          getListProductSame(sku).then((response) => {
            if(response !== undefined && response.status === 200){
                setdataItems(response['message']);
            }
        });     
      } catch(err) {
        console.error(err);
      }   
    },[]
    );
    const handleRedirect =(uri)=>{
      window.location.href = '/mobile'+uri;
  }
  if(dataItems?.length>0){
  return(
        <div className="row mgt-10 pdt-10 bg-white">
        <div className="row mgx-0">
          <div className="col-8 infor-product-title">
              <span>Sản phẩm tương tự</span>
          </div>
          <div className="col-4 header-right color-red-i" onClick={()=>handleRedirect('/san-pham-tuong-tu.html?'+sku)}>
              <span>Xem tất cả</span>
              <i className="fa fa-angle-right fa-1"></i>
              <i className="fa fa-angle-right fa-1"></i>
          </div>
        </div>

        <div className="col-12 product-similar mgt-10 pdx-0">
        <div className="row mgx-0">
            <Carousel key="product-the-same-mobile"
                responsive={responsiveproductlistmobile}
                fade={true}
            >
                    { 
                        dataItems.map((item, index)=>(
                                <ItemDefault key={index} item={item} index={index}/>
                            ))
                    } 
            </Carousel>
        </div>
    </div>
    </div>
  )
}else{
  return null;
}
}

export default ProductSame